import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { MdlModule } from '@angular-mdl/core';

import { TranslateModule } from '../../../translate/translate.module';

import { CommunicationMenuComponent } from './communication-menu.component';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    TranslateModule,
    MdlModule
  ],
  declarations: [
    CommunicationMenuComponent
  ],
  exports: [CommunicationMenuComponent]
})
export class CommunicationMenuModule { }
